import { render, staticRenderFns } from "./wxCustomerList.vue?vue&type=template&id=aa4664d6&scoped=true&"
import script from "./wxCustomerList.vue?vue&type=script&lang=js&"
export * from "./wxCustomerList.vue?vue&type=script&lang=js&"
import style0 from "./wxCustomerList.vue?vue&type=style&index=0&id=aa4664d6&scoped=true&lang=css&"
import style1 from "./wxCustomerList.vue?vue&type=style&index=1&lang=less&"
import style2 from "./wxCustomerList.vue?vue&type=style&index=2&lang=css&"
import style3 from "./wxCustomerList.vue?vue&type=style&index=3&id=aa4664d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa4664d6",
  null
  
)

export default component.exports